import { View } from "react-native";

export function ProgressBar({
  value,
  size = "md",
  theme = "light",
}: {
  value: number;
  size?: "sm" | "md" | "lg";
  theme?: "light" | "dark";
}) {
  const clamped = Math.max(0, Math.min(1, value));
  const h = size === "sm" ? 3 : size === "lg" ? 6 : 4;
  const track = theme === "dark" ? "bg-white/10" : "bg-sand-dark";
  return (
    <View className={`overflow-hidden rounded-[2px] ${track}`} style={{ height: h }}>
      <View className="h-full rounded-[2px] bg-amber" style={{ width: `${clamped * 100}%` }} />
    </View>
  );
}
